/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：V8ar
 */

// removed by extract-text-webpack-plugin
module.exports = {
  "playVideoBox": "playVideoBox_3R8bQ",
  "content": "content_1lamM",
  "videoTitle": "videoTitle_34-sw",
  "title": "title_2GIfX",
  "icon": "icon_2TXPU",
  "videoBox": "videoBox_ZcRCJ",
  "video": "video_3wFvn",
  "playBox": "playBox_1r8Q0",
  "playIconBox": "playIconBox_2M8e4",
  "playIconItem": "playIconItem_3v39u",
  "playIcon": "playIcon_32Gw_",
  "play": "play_pyrqt",
  "replay": "replay_31haf",
  "nextVideo": "nextVideo_MpYAL",
  "openWorkBtn": "openWorkBtn_1cx3x",
  "courseInfo": "courseInfo_wrVIX",
  "desc": "desc_16Cms",
  "btn": "btn_Xghow"
}

/***/
